import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { primaryColor, secondaryColor } from "../../utils/comon";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import storageService from "../../utils/storageService";
import { getTenantPrefix } from "../../utils/tenantHelper";
import apiServices from "../../services/apiService";
import encryptedDataService from "../../services/encryptedDataService";

const getMaterialIcon = (iconName) => {
    if (!iconName) return 'circle';
    const name = iconName.toLowerCase().trim();
    if (name === 'building') return 'business';
    if (name === 'managment') return 'business';
    return name;
};

const mapUrl = (url) => {
    if (!url) return "";

    let mapped = url;

    if (mapped.startsWith('/')) {
        mapped = mapped.slice(1);
    }

    // Strip known app prefixes to avoid double-prefixing
    if (mapped.startsWith('commercial/')) {
        mapped = mapped.replace('commercial/', '');
    }
    if (mapped.startsWith('zentres/')) {
        mapped = mapped.replace('zentres/', '');
    }
    if (mapped.startsWith('zentech/')) {
        mapped = mapped.replace('zentech/', '');
    }
    if (mapped.startsWith('zentcomm/')) {
        mapped = mapped.replace('zentcomm/', '');
    }

    // // Map attendance-management to attendance
    // if (mapped === 'attendance-management' || mapped === 'attendance-management/' || mapped === 'attendance-managemnet' || mapped === 'attendance-managemnet/') {
    //     mapped = 'attendance';
    // }

    // // Map announcement to announcements
    // if (mapped === 'announcement' || mapped === 'announcement/' || mapped === 'announcements' || mapped === 'announcements/') {
    //     mapped = 'announcements';
    // }

    // Dynamically set prefix based on current tenant name
    const prefix = getTenantPrefix();

    return prefix + mapped;
};

const Sidebar = ({ closeSidebar, toggleSidebar }) => {
    const location = useLocation();
    const [openSubMenus, setOpenSubMenus] = useState({});
    const [menuData, setMenuData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        const fetchMenu = async () => {
            setIsLoading(true);
            let employeeCode = user?.userId || user?.Id || user?.id;
            if (!employeeCode) {
                employeeCode = storageService.getItem("employeeCode");
            }
            const tenantName = storageService.getItem("Tenant_Name");

            if (!employeeCode) {
                setIsLoading(false);
                return;
            }

            let endpoint = "";
            if (tenantName === 'main') {
                endpoint = `/TenantMenuListMaster/getAllTenantMenuListByEmployeeCode/${employeeCode}`;
            } else {
                endpoint = `/MenuList/getAllMenuList/${employeeCode}`;
            }

            try {
                const res = await apiServices({
                    method: "GET",
                    url: endpoint
                });

                if (res?.success) {
                    const responseData = res?.data?.menuListResponse || res?.menuListResponse || res?.data?.data?.menuListResponse;
                    if (responseData && Array.isArray(responseData)) {
                        let finalMenuData = [];
                        // Relaxing the active check since the API sometimes returns `""` instead of `"Active"`
                        const activeMenus = responseData.filter(item => item?.isActive !== 'Inactive' && item?.isActive !== false);

                        if (tenantName === 'main') {
                            const isDashboard = (name) => {
                                const n = (name || "").trim().toLowerCase();
                                return n === "dashboard" || n === "";
                            };
                            const dashboardItem = activeMenus.find(item => isDashboard(item?.menuName));
                            const otherItems = activeMenus.filter(item => !isDashboard(item?.menuName));
                            const sortData = otherItems.sort((a, b) => (a.menuName || "").localeCompare(b.menuName || ""));

                            if (dashboardItem) {
                                sortData.unshift(dashboardItem);
                            }
                            finalMenuData = sortData;
                        } else {
                            finalMenuData = activeMenus;
                        }

                        // Also filter submenus if they have an isActive property
                        finalMenuData = finalMenuData.map(item => {
                            if (item.subMenuList && Array.isArray(item.subMenuList)) {
                                return {
                                    ...item,
                                    subMenuList: item.subMenuList.filter(sub => sub?.isActive !== 'Inactive' && sub?.isActive !== false)
                                };
                            }
                            return item;
                        });

                        // Dynamically inject Attendance as a separate main menu item

                        setMenuData(finalMenuData);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch menu list", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (user) {
            fetchMenu();
        }
    }, [user]);

    const isPathActive = (path) => {
        if (!path) return false;
        const mapped = mapUrl(path);
        return location.pathname === mapped || location.pathname.startsWith(mapped + '/');
    };

    const toggleSubMenu = (menuId) => {
        setOpenSubMenus(prev => {
            if (prev[menuId]) {
                return {};
            }
            return { [menuId]: true };
        });
    };

    useEffect(() => {
        if (menuData.length > 0) {
            const activeMenu = menuData.find(menu =>
                menu.subMenuList && menu.subMenuList.some(sub => isPathActive(sub.menuUrl))
            );
            if (activeMenu) {
                setOpenSubMenus({ [activeMenu.menuListId]: true });
            }
        }
    }, [location.pathname, menuData]);

    return (
        <div className="h-full w-full bg-dashboardbg flex flex-col justify-between overflow-y-auto scrollbar-hide rounded-xl shadow-sm border border-bordercolor">
            <div className="p-2 flex flex-col gap-1">
                <div className='hidden lg:flex items-center justify-end px-2'>
                    <span className="material-symbols-outlined text-[#555555] dark:text-textsecondary cursor-pointer" onClick={toggleSidebar}>
                        dock_to_right
                    </span>
                </div>

                {isLoading ? (
                    Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="flex items-center justify-between px-3 py-3 rounded-xl animate-pulse">
                            <div className="flex items-center gap-3 w-full">
                                <div className="w-[18px] h-[18px] bg-slate-200 rounded-full"></div>
                                <div className="h-2.5 bg-slate-200 rounded w-2/3"></div>
                            </div>
                        </div>
                    ))
                ) : (
                    menuData.map((item) => {
                        // Angular uses subMenuList
                        const hasSubMenu = item.subMenuList && item.subMenuList.length > 0;
                        const isOpen = openSubMenus[item.menuListId];
                        const isAnySubActive = hasSubMenu && item.subMenuList.some(sub => isPathActive(sub.menuUrl));
                        const isActiveMain = !hasSubMenu && isPathActive(item.menuUrl);

                        return (
                            <div key={item.menuListId} className="flex flex-col">
                                {/* Main Menu Item */}
                                {!hasSubMenu ? (
                                    <NavLink
                                        to={mapUrl(item.menuUrl)}
                                        onClick={closeSidebar}
                                        className={`flex items-center justify-between px-3 py-2.5 rounded-md transition-all duration-200 group border-l-2 ${isActiveMain
                                            ? "font-bold bg-secondaryaccent text-primaryaccent border-primaryaccent"
                                            : "text-[#555555] dark:text-textsecondary border-transparent hover:bg-appbg"
                                            }`}
                                    >
                                        <div className="flex items-center gap-3">
                                            <span className="material-symbols-outlined text-[18px]">
                                                {getMaterialIcon(item.menuIcon)}
                                            </span>
                                            <span className="text-[11px] font-bold tracking-wider uppercase">{item.menuName === '' ? 'Dashboard' : item.menuName}</span>
                                        </div>
                                    </NavLink>
                                ) : (
                                    <div
                                        onClick={() => toggleSubMenu(item.menuListId)}
                                        className={`flex items-center justify-between px-3 py-3 rounded-xl cursor-pointer transition-all duration-200 group ${isAnySubActive ? "bg-secondaryaccent text-primaryaccent" : "text-[#555555] dark:text-textsecondary hover:bg-appbg"
                                            }`}
                                    >
                                        <div className="flex items-center gap-3">
                                            <span className="material-symbols-outlined text-[18px]">{getMaterialIcon(item.menuIcon)}</span>
                                            <span className="text-[11px] font-bold tracking-wider uppercase">{item.menuName}</span>
                                        </div>
                                        <FontAwesomeIcon
                                            icon={isOpen ? faChevronDown : faChevronRight}
                                            className={`text-[10px] transition-transform duration-200 ${isOpen ? "rotate-0" : ""}`}
                                        />
                                    </div>
                                )}

                                {/* Sub Menu Items */}
                                {hasSubMenu && isOpen && (
                                    <div className="flex flex-col mt-1 mb-2">
                                        {item.subMenuList.map((sub) => {
                                            const isActiveSub = isPathActive(sub.menuUrl);
                                            return (
                                                <NavLink
                                                    key={sub.menuListId || sub.menuUrl}
                                                    to={mapUrl(sub.menuUrl)}
                                                    onClick={closeSidebar}
                                                    className={`flex items-center gap-3 py-2.5 px-4 ml-2 rounded-md transition-all duration-200 border-l-2 ${isActiveSub
                                                        ? "font-normal bg-secondaryaccent text-primaryaccent border-primaryaccent"
                                                        : "text-[#555555] dark:text-textsecondary border-transparent hover:bg-appbg"
                                                        }`}
                                                >
                                                    <span className="text-[13px] uppercase">{sub.menuName}</span>
                                                </NavLink>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default Sidebar;